import { graphql } from "relay-runtime"

export const ControlAppContextPreloadedQuery = graphql`
  query ControlAppContextQuery {
    viewer {
      ...ControlAuthUserContextFragment @relay(mask: false)
    }
  }
`
